export class Lieferung {

  constructor(lieferungId: string, status: string,name: string, erstellzeitpunkt:string, geschaeftsvorgangs: Geschaeftsvorgang[]) {
    this.lieferungId = lieferungId;
    this.status = status;
    this.name = name;
    this.erstellzeitpunkt = erstellzeitpunkt;
    this.geschaeftsvorgangs = geschaeftsvorgangs;

  }

  public lieferungId: string;
  public status: string;
  public name: string;
  public erstellzeitpunkt: string;
  public geschaeftsvorgangs: Geschaeftsvorgang[];

}


export class Geschaeftsvorgang{
  constructor(anliegenId: string, ordnungsmerkmalExtern : string, vertragIDAllianz: string, gevoArtWert: string, statusWert: string) {
    this.anliegenId = anliegenId;
    this.ordnungsmerkmalExtern = ordnungsmerkmalExtern;
    this.vertragIDAllianz = vertragIDAllianz;
    this.gevoArtWert = gevoArtWert;
    this.statusWert = statusWert;
  }

  public anliegenId: string;
  public ordnungsmerkmalExtern: string;
  public vertragIDAllianz: string;
  public gevoArtWert: string;
  public statusWert: string;
}
